import React from 'react';
import classnames from 'classnames';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import AddSvg from '@src/svgs/fr-plus.svg';
import MinusSvg from '@src/svgs/fr-minus.svg';
import { MAX_SLOTS_COUNT, MIN_SLOTS_COUNT } from '@src/constants';

export const SlotsCounter = ({ slotsInUse, counter, setCounter }) => {
  slotsInUse = slotsInUse || 0;
  counter = counter || MIN_SLOTS_COUNT;

  const onChange = value => {
    if (value >= slotsInUse && value <= MAX_SLOTS_COUNT && counter !== value) {
      setCounter(value);
    }
  };

  return (
    <div className="subscription-modal__slots">
      <div>
        <div className="subscription-modal__slots-title">Opening slots</div>
        <div className="subscription-modal__slots-subtitle">
          You are currently using {slotsInUse} {pluralize('slots', slotsInUse)}.
        </div>
      </div>
      <div className="subscription-modal__slots-counter">
        <Svg
          className={classnames('subscription-modal__slots-counter-control', {
            'subscription-modal__slots-counter-control--disabled': counter <= slotsInUse || counter <= MIN_SLOTS_COUNT,
          })}
          onClick={() => onChange(counter - 1)}
          src={MinusSvg}
        />
        <span className="subscription-modal__slots-counter-value">{counter}</span>
        <Svg
          className={classnames('subscription-modal__slots-counter-control', {
            'subscription-modal__slots-counter-control--disabled': counter >= MAX_SLOTS_COUNT,
          })}
          onClick={() => onChange(counter + 1)}
          src={AddSvg}
        />
      </div>
    </div>
  );
};

SlotsCounter.propTypes = {
  counter: PropTypes.number.isRequired,
  setCounter: PropTypes.func.isRequired,
  slotsInUse: PropTypes.number.isRequired,
};
